import { render, staticRenderFns } from "./DefaultRulePropertie.vue?vue&type=template&id=466a2431&"
import script from "./DefaultRulePropertie.vue?vue&type=script&lang=js&"
export * from "./DefaultRulePropertie.vue?vue&type=script&lang=js&"
import style0 from "./DefaultRulePropertie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports